export default function progressSteps () {
  const meter = document.querySelector('.Progress')
  if (!meter) {
    return
  }

  const circles = meter.querySelectorAll('.meter-bar')
  const percentageDone = meter.dataset.currentStep / meter.dataset.totalSteps
  const rotate = Math.ceil(percentageDone * 180)
  const rotateTime = Math.ceil(percentageDone * 3).toString() + 's'

  Array.of(...circles).forEach(circle => {
    circle.style.transitionDuration = rotateTime
    setTimeout(() => {
      circle.style.transform = `rotate(${rotate}deg)`

    }, 300)
  })
}
